// 本地存储工具函数

import Cookies from "js-cookie";

const UserInfoKey = "User_Info";

const MinioUrlKey = "Minio-Url";

// 用户信息类型定义
export interface UserInfo {
  userId: string;
  username: string;
  nickname: string;
  roleId: number;
  token: string;
  expireTime: string;
  roleList?: Array<{
    roleId: number;
    roleName: string;
    roleKey: string;
  }>;
  currentRoleName?: string;
}

// 存储用户信息
export const setUserInfo = (userInfo: UserInfo) => {
  Cookies.set(UserInfoKey, JSON.stringify(userInfo));
};

// 获取用户信息
export const getUserInfo = (): UserInfo | null => {
  const userInfo = Cookies.get(UserInfoKey);
  return userInfo ? JSON.parse(userInfo) : null;
};

// 更新用户角色ID
export const updateUserRole = (key: keyof UserInfo, value: any) => {
  const userInfo = getUserInfo();
  if (userInfo) {
    userInfo[key as keyof UserInfo] = value as never;
    setUserInfo(userInfo);
  }
};

// 切换用户角色（更新roleId和roleName，并重定向到首页）
export const switchUserRole = (roleId: number, roleName: string) => {
  const userInfo = getUserInfo();
  if (userInfo) {
    userInfo.roleId = roleId;
    userInfo.currentRoleName = roleName;
    setUserInfo(userInfo);
    // 重定向到首页并刷新页面以重新加载权限
    window.location.href = '/';
  }
};

// 清除用户信息
export const clearUserInfo = () => {
  Cookies.remove(UserInfoKey);
};

export function getMinioUrl() {
  return Cookies.get(MinioUrlKey);
}

export function setMinioUrl(minioUrl: string) {
  return Cookies.set(MinioUrlKey, minioUrl);
}
